export const formatAuditDateTime = (isoString) => {
  if (!isoString) return '';
  const date = new Date(isoString);
  if (Number.isNaN(date.getTime())) return String(isoString);
  return date.toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
};

/** Stacked When column: date (MMM DD, YYYY) + time on separate lines. */
export const formatAuditStackedDateTime = (isoString) => {
  if (!isoString) return { date: '', time: '' };
  const date = new Date(isoString);
  if (Number.isNaN(date.getTime())) return { date: String(isoString), time: '' };
  return {
    date: date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    }),
    time: date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
    }),
  };
};

export const formatRoleLabel = (role) => {
  if (!role) return '';
  const normalized = String(role).replace(/_/g, ' ').toLowerCase();
  return normalized.charAt(0).toUpperCase() + normalized.slice(1);
};

